module.exports = __webpack_public_path__ + "img/jingke1.8a756ccc.png";